export default __webpack_public_path__ + "static/media/terms_policy.604bff33.svg";